/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * LearningModuleStatBase
 * auto generated base class for the model LearningModuleStatModel.
 */
export const LearningModuleStatModelBase = ModelBase.named('LearningModuleStat')
  .props({
    __typename: types.optional(types.literal('LearningModuleStat'), 'LearningModuleStat'),
    _id: types.identifier,
    accuracy: types.union(types.undefined, types.number),
    completedTimes: types.union(types.undefined, types.number),
    createdAt: types.union(types.undefined, types.frozen()),
    moduleCompletedTime: types.union(types.undefined, types.frozen()),
    moduleId: types.union(types.undefined, types.number),
    moduleName: types.union(types.undefined, types.string),
    updatedAt: types.union(types.undefined, types.frozen()),
    userId: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class LearningModuleStatModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get accuracy() {
    return this.__attr('accuracy')
  }
  get completedTimes() {
    return this.__attr('completedTimes')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get moduleCompletedTime() {
    return this.__attr('moduleCompletedTime')
  }
  get moduleId() {
    return this.__attr('moduleId')
  }
  get moduleName() {
    return this.__attr('moduleName')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userId() {
    return this.__attr('userId')
  }
}
export function selectFromLearningModuleStat() {
  return new LearningModuleStatModelSelector()
}

export const learningModuleStatModelPrimitives =
  selectFromLearningModuleStat()._id.accuracy.completedTimes.createdAt.moduleCompletedTime.moduleId.moduleName.updatedAt
    .userId
